import axios from 'axios';

const TEAMLIO_AUTH_URL =
  process.env.REACT_APP_TEAMLIO_AUTH_URL || 'http://localhost:8000';

export interface LoginPayload {
  email: string;
  password: string;
}

export interface LoginResult {
  access_token: string;
  refresh_token?: string;
  user?: {
    id: string;
    email: string;
    first_name?: string;
    last_name?: string;
    avatar_url?: string;
    [k: string]: unknown;
  };
}

export async function login(payload: LoginPayload): Promise<LoginResult> {
  // TeamLeo's /api/auth/login uses OAuth2PasswordRequestForm — expects
  // application/x-www-form-urlencoded with `username` (the email) and
  // `password`. JSON bodies fail with a 422 "field required: username".
  const form = new URLSearchParams();
  form.append('username', payload.email);
  form.append('password', payload.password);

  const { data } = await axios.post(
    `${TEAMLIO_AUTH_URL}/api/auth/login`,
    form,
    {
      timeout: 15000,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    }
  );
  if (!data?.access_token) {
    throw new Error('No access token in TeamLeo login response');
  }
  return data;
}

export async function refresh(refreshToken: string): Promise<LoginResult> {
  const { data } = await axios.post(
    `${TEAMLIO_AUTH_URL}/api/auth/refresh`,
    { refresh_token: refreshToken },
    { timeout: 15000 }
  );
  return data;
}

export function logout(): void {
  try {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
  } catch {
    /* ignore */
  }
}
